<template>
  <div class="g-page">

    <!-- ═══════════════ HEADER ═══════════════ -->
    <div class="header-row">
      <h2 class="page-title">Ustalar</h2>
      <div class="header-actions">
        <div class="search-wrap">
          <svg class="s-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
          <input v-model="search" type="text" placeholder="Qidiruv..." class="search-input" />
        </div>
        <button class="btn-add-header" @click="openUstaModal()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg>
          Yangi usta
        </button>
        <button class="btn-att-header" @click="openAttendanceModal()">
          Davomat
        </button>
        <Top />
      </div>
    </div>

    <!-- ═══════════════ JADVAL ═══════════════ -->
    <div class="table-card">
      <div class="table-wrap">
        <table class="ctable">
          <thead>
            <tr>
              <th class="th-left">ISMI</th>
              <th>OYLIK</th>
              <th>BONUS</th>
              <th>KIRIM</th>
              <th>CHIQIM</th>
              <th>BALANS</th>
              <th>DAVOMAT</th>
              <th>AMALLAR</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="fetchLoading">
              <td colspan="8" class="empty-row">Yuklanmoqda...</td>
            </tr>
            <tr v-else-if="filteredData.length === 0">
              <td colspan="8" class="empty-row">Ma'lumot topilmadi</td>
            </tr>
            <tr
              v-for="row in filteredData"
              :key="row.id"
              class="trow"
              @click="openHistory(row.id, row.name)"
            >
              <td class="td-left">
                <div class="m-name">{{ row.name }}</div>
                <div class="m-phone">{{ getStaff(row.id).phone_number }}</div>
              </td>
              <td class="td-blue">{{ fmtM(getStaff(row.id).salary) }}</td>
              <td class="td-gray">{{ getStaff(row.id).bonus || 0 }} %</td>
              <td class="td-blue">{{ fmtM(row.kirim_summa) }}</td>
              <td class="td-red">{{ fmtM(row.chiqim_summa) }}</td>
              <td :class="(row.kirim_summa - row.chiqim_summa) < 0 ? 'td-red td-bold' : 'td-dark td-bold'">
                {{ fmtM(row.kirim_summa - row.chiqim_summa) }}
              </td>
              <td @click.stop>
                <button
                  class="att-btn"
                  :class="{ active: row.attendedToday }"
                  :disabled="attendanceLoadingId === row.id"
                  @click="toggleAttendance(row)"
                >
                  {{ row.attendedToday ? 'Keldi' : 'Bugun keldi' }}
                </button>
              </td>
              <td @click.stop>
                <div class="act-btns">
                  <button class="act-btn pay" title="To'lov qilish" @click="openPayModal(row)">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="1" y="4" width="22" height="16" rx="2"/><path d="M1 10h22"/></svg>
                  </button>
                  <button class="act-btn edit" title="Tahrirlash" @click="openUstaModal(row.id)">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  </button>
                  <button class="act-btn del" title="O'chirish" @click="deleteMaster(row.id)">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ═══════════════ MODAL 1: USTA CRUD ═══════════════ -->
    <div v-if="attendanceModal.show" class="overlay" @click.self="attendanceModal.show = false">
      <div class="modal-box attendance-modal-box">
        <div class="modal-head">
          <h3 class="modal-title">Davomat</h3>
          <div class="attendance-head-actions">
            <input
              v-model="attendanceModal.month"
              type="month"
              class="month-input"
              @change="loadAttendanceMonth"
            />
            <button class="close-btn" @click="attendanceModal.show = false">&times;</button>
          </div>
        </div>
        <div class="attendance-body">
          <div v-if="attendanceModal.loading" class="empty-row">Yuklanmoqda...</div>
          <div v-else class="attendance-table-wrap">
            <table class="attendance-table">
              <thead>
                <tr>
                  <th class="att-name-col">Usta</th>
                  <th
                    v-for="day in attendanceDays"
                    :key="day.date"
                    class="att-day-col"
                    :class="{ sunday: day.weekday === 0 }"
                  >
                    <span>{{ day.day }}</span>
                    <small>{{ day.label }}</small>
                  </th>
                  <th class="att-total-col">Jami</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="master in masters" :key="master.id">
                  <td class="att-name-col">
                    <div class="m-name">{{ master.name }}</div>
                    <div class="m-phone">{{ fmtM(master.salary) }}</div>
                  </td>
                  <td
                    v-for="day in attendanceDays"
                    :key="master.id + '-' + day.date"
                    class="att-day-cell"
                    :class="{ active: hasAttendance(master.id, day.date), sunday: day.weekday === 0 }"
                  >
                    <button
                      class="att-cell-btn"
                      :disabled="attendanceModal.cellLoading === attendanceKey(master.id, day.date)"
                      @click="toggleAttendanceCell(master.id, day.date)"
                    >
                      {{ hasAttendance(master.id, day.date) ? '✓' : '' }}
                    </button>
                  </td>
                  <td class="att-total-col">{{ attendanceCountForStaff(master.id) }}</td>
                </tr>
                <tr v-if="masters.length === 0">
                  <td :colspan="attendanceDays.length + 2" class="empty-row">Ustalar topilmadi</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="ustaModal.show" class="overlay" @click.self="ustaModal.show = false">
      <div class="modal-box">
        <div class="modal-head">
          <h3 class="modal-title">{{ ustaModal.id ? 'Ustani tahrirlash' : 'Yangi usta' }}</h3>
          <button class="close-btn" @click="ustaModal.show = false">&times;</button>
        </div>
        <div class="modal-body">
          <div class="field-group">
            <label class="flabel">Ism familiya</label>
            <input v-model="ustaModal.name" type="text" class="finput" placeholder="Ismi..." />
          </div>
          <div class="field-group">
            <label class="flabel">Telefon raqami</label>
            <input v-model="ustaModal.phone" type="text" class="finput" placeholder="+998 (__) ___ __ __" />
          </div>
          <div class="field-row-2">
            <div class="field-group">
              <label class="flabel">Oylik maoshi (so'm)</label>
              <input v-model.number="ustaModal.salary" type="number" class="finput" placeholder="0" />
            </div>
            <div class="field-group">
              <label class="flabel">Bonus foizi (%)</label>
              <input v-model.number="ustaModal.bonus" type="number" class="finput" placeholder="0" />
            </div>
          </div>
        </div>
        <div class="modal-foot">
          <button class="btn-cancel-m" @click="ustaModal.show = false">Bekor</button>
          <button class="btn-save-m" @click="saveUsta" :disabled="ustaModal.loading">
            {{ ustaModal.loading ? 'Saqlanmoqda...' : 'Saqlash' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════ MODAL 2: TO'LOV ═══════════════ -->
    <div v-if="payModal.show" class="overlay" @click.self="payModal.show = false">
      <div class="modal-box pay-modal-box">
        <div class="modal-head">
          <h3 class="modal-title">Ustaga to'lov</h3>
          <button class="close-btn" @click="payModal.show = false">&times;</button>
        </div>
        <div class="modal-body">

          <!-- Tanlangan usta -->
          <div class="master-badge">
            <div class="master-avatar">{{ payModal.masterName ? payModal.masterName[0] : 'U' }}</div>
            <div>
              <div class="master-badge-name">{{ payModal.masterName }}</div>
              <div class="master-badge-info">
                Oylik: <strong>{{ fmtM(payModal.masterSalary) }}</strong>
                &nbsp;·&nbsp;
                Balans: <strong :class="payModal.masterBalance < 0 ? 'c-red' : 'c-green'">{{ fmtM(payModal.masterBalance) }}</strong>
              </div>
            </div>
          </div>

          <!-- To'lov sababi (tabs) -->
          <div class="field-group">
            <label class="flabel">To'lov sababi</label>
            <div class="reason-grid">
              <button
                v-for="r in payReasons"
                :key="r.value"
                class="reason-btn"
                :class="{ active: payModal.reason === r.value }"
                @click="selectReason(r.value)"
              >
                <span class="r-icon">{{ r.icon }}</span>
                {{ r.label }}
              </button>
            </div>
          </div>

          <!-- Summa -->
          <div class="field-group">
            <div class="label-row">
              <label class="flabel">Summa</label>
              <button
                v-if="quickAmount > 0"
                class="quick-btn"
                @click="fillQuick"
              >⚡ {{ shortM(quickAmount) }}</button>
            </div>
            <input
              type="text"
              :value="payModal.displayAmount"
              @input="handleAmount"
              class="finput finput-lg"
              placeholder="0"
            />
          </div>

          <!-- To'lov usuli -->
          <div class="field-group">
            <label class="flabel">To'lov usuli</label>
            <div class="pay-type-grid">
              <button
                v-for="pt in payTypes"
                :key="pt.id"
                class="pay-type-btn"
                :class="{ active: payModal.pay_type_id === pt.id }"
                @click="payModal.pay_type_id = pt.id"
              >{{ pt.name }}</button>
            </div>
          </div>

          <!-- Izoh -->
          <div class="field-group">
            <label class="flabel">Izoh (ixtiyoriy)</label>
            <input v-model="payModal.comment" type="text" class="finput" placeholder="Masalan: Noyabr oylik..." />
          </div>
        </div>
        <div class="modal-foot">
          <button class="btn-cancel-m" @click="payModal.show = false">Bekor</button>
          <button class="btn-pay-m" @click="submitPay" :disabled="payModal.loading">
            {{ payModal.loading ? 'Saqlanmoqda...' : 'To\'lash' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════ MODAL 3: TARIX ═══════════════ -->
    <div v-if="historyModal.show" class="overlay" @click.self="historyModal.show = false">
      <div class="modal-box history-modal-box">
        <div class="modal-head">
          <h3 class="modal-title">{{ historyModal.name }} — Operatsiyalar</h3>
          <button class="close-btn" @click="historyModal.show = false">&times;</button>
        </div>
        <div class="modal-body" style="padding:0;">
          <table class="ctable">
            <thead>
              <tr>
                <th class="th-left" style="padding-left:20px;width:40px"></th>
                <th class="th-left">Sana</th>
                <th>Sabab / Tur</th>
                <th>Summa</th>
              </tr>
            </thead>
            <tbody v-if="historyModal.loading">
              <tr><td colspan="4" class="empty-row">Yuklanmoqda...</td></tr>
            </tbody>
            <tbody v-else-if="historyModal.data.length === 0">
              <tr><td colspan="4" class="empty-row">Operatsiya yo'q</td></tr>
            </tbody>
            <tbody v-for="item in historyModal.data" :key="item.id">
              <tr :class="{ 'h-clickable': item.sale_details }" @click="item.sale_details ? toggleHistoryExpand(item.id) : null">
                <td style="padding-left:20px">
                  <span v-if="item.sale_details" class="h-expand-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                      <polyline v-if="historyExpandedId === item.id" points="18 15 12 9 6 15"/>
                      <polyline v-else points="6 9 12 15 18 9"/>
                    </svg>
                  </span>
                </td>
                <td class="td-left" style="font-size:12px;">{{ fmtDate(item.created_at) }}</td>
                <td>
                  <span class="type-tag" :class="item.type === 'chiqim' ? 'tag-red' : 'tag-green'">
                    {{ item.doc_type || item.type }}
                  </span>
                  <span v-if="item.sale_details" class="percent-tag">
                    {{ item.sale_details.master_percent }}% · {{ item.sale_details.sale_type === 'optom' ? 'Optom' : 'Chakana' }}
                  </span>
                </td>
                <td :class="item.type === 'chiqim' ? 'td-red td-bold' : 'td-blue td-bold'">
                  {{ fmtM(item.summa) }}
                </td>
              </tr>

              <!-- Savdo tafsilotlari -->
              <tr v-if="historyExpandedId === item.id && item.sale_details" class="h-detail-row">
                <td colspan="4" style="padding:0;">
                  <div class="h-detail-container">
                    <div class="h-detail-title">Xizmatlar (Savdo #{{ item.sale_details.sale_id }})</div>
                    <table class="h-inner-table">
                      <thead>
                        <tr>
                          <th>Xizmat</th>
                          <th class="text-right">Ish haqi</th>
                          <th class="text-right">Peredelka</th>
                          <th class="text-right">Jami</th>
                          <th class="text-right">{{ item.sale_details.master_percent }}%</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(srv, idx) in item.sale_details.services" :key="idx">
                          <td>{{ srv.name }}</td>
                          <td class="text-right">{{ fmtM(srv.labor_price) }}</td>
                          <td class="text-right">{{ fmtM(srv.redo_price) }}</td>
                          <td class="text-right">{{ fmtM(srv.total) }}</td>
                          <td class="text-right td-blue td-bold">{{ fmtM(srv.master_share) }}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="3" class="text-right" style="font-weight:800">JAMI:</td>
                          <td class="text-right" style="font-weight:800">{{ fmtM(sumServicesTotal(item.sale_details.services)) }}</td>
                          <td class="text-right td-blue" style="font-weight:800">{{ fmtM(sumMasterShare(item.sale_details.services)) }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import Top from '../Layout/Top.vue';

export default {
  components: { Top },

  data() {
    return {
      search: '',
      fetchLoading: false,
      masters: [],
      staffBalances: [],
      todayAttendance: [],
      attendanceLoadingId: null,
      payTypes: [],
      attendanceModal: {
        show: false,
        loading: false,
        month: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`,
        data: [],
        cellLoading: null,
      },

      payReasons: [
        { value: 'Oylik',       label: 'Oylik',       icon: '📅' },
        { value: 'Kunlik',      label: 'Kunlik',       icon: '📆' },
        { value: 'Fiksa oylik', label: 'Fiksa',        icon: '📌' },
        { value: 'Bonus',       label: 'Bonus',        icon: '🎁' },
      ],

      // Modal 1 — CRUD
      ustaModal: {
        show: false, loading: false,
        id: null, name: '', phone: '+998 ', salary: 0, bonus: 0,
      },

      // Modal 2 — To'lov
      payModal: {
        show: false, loading: false,
        staffId: null, masterName: '', masterSalary: 0, masterBalance: 0,
        reason: 'Oylik',
        amount: 0, displayAmount: '',
        pay_type_id: null,
        comment: '',
      },

      // Modal 3 — Tarix
      historyModal: {
        show: false, loading: false,
        name: '', data: [],
      },
      historyExpandedId: null,
    };
  },

  computed: {
    allRows() {
      return this.masters.map(m => {
        const bal = this.staffBalances.find(b => b.id === m.id) || {};
        return {
          id:           m.id,
          name:         m.name,
          kirim_summa:  Number(bal.kirim_summa  || 0),
          chiqim_summa: Number(bal.chiqim_summa || 0),
          attendedToday: this.todayAttendance.some(a => Number(a.staff_id) === Number(m.id)),
        };
      });
    },

    filteredData() {
      if (!this.search) return this.allRows;
      const q = this.search.toLowerCase();
      return this.allRows.filter(r => r.name.toLowerCase().includes(q));
    },

    quickAmount() {
      const salary = Number(this.payModal.masterSalary || 0);
      if (!salary) return 0;
      if (this.payModal.reason === 'Kunlik') return Math.round(salary / 30);
      if (this.payModal.reason === 'Bonus') return 0;
      return salary;
    },

    attendanceDays() {
      const [year, month] = this.attendanceModal.month.split('-').map(Number);
      if (!year || !month) return [];
      const count = new Date(year, month, 0).getDate();
      const labels = ['Ya', 'Du', 'Se', 'Ch', 'Pa', 'Ju', 'Sh'];
      return Array.from({ length: count }, (_, i) => {
        const date = new Date(year, month - 1, i + 1);
        return {
          day: i + 1,
          date: this.localDate(date),
          weekday: date.getDay(),
          label: labels[date.getDay()],
        };
      });
    },
  },

  mounted() { this.fetchData(); },

  methods: {
    // ── Data ──
    async fetchData() {
      this.fetchLoading = true;
      try {
        const [s, b, p, a] = await Promise.all([
          axios.get('/api/v1/staff'),
          axios.get('/api/v1/staff_register'),
          axios.get('/api/v1/pay-type'),
          axios.get('/api/v1/staff-attendance', { params: { date: this.localDate() } }),
        ]);
        this.masters       = s.data.data || [];
        this.staffBalances = b.data.data || [];
        this.payTypes      = p.data      || [];
        this.todayAttendance = a.data.data || [];
      } catch (e) { console.error(e); }
      finally { this.fetchLoading = false; }
    },

    getStaff(id) {
      return this.masters.find(m => m.id === id) || {};
    },

    // ── CRUD Modal ──
    monthStr(d = new Date()) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      return `${y}-${m}`;
    },

    localDate(d = new Date()) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },

    attendanceKey(staffId, date) {
      return `${staffId}_${date}`;
    },

    hasAttendance(staffId, date) {
      return this.attendanceModal.data.some(
        a => Number(a.staff_id) === Number(staffId) && a.attendance_date === date
      );
    },

    attendanceCountForStaff(staffId) {
      return this.attendanceModal.data.filter(a => Number(a.staff_id) === Number(staffId)).length;
    },

    async openAttendanceModal() {
      this.attendanceModal.show = true;
      if (!this.attendanceModal.month) this.attendanceModal.month = this.monthStr();
      await this.loadAttendanceMonth();
    },

    async loadAttendanceMonth() {
      if (!this.attendanceModal.month) return;
      const [year, month] = this.attendanceModal.month.split('-').map(Number);
      const date1 = this.localDate(new Date(year, month - 1, 1));
      const date2 = this.localDate(new Date(year, month, 0));
      this.attendanceModal.loading = true;
      try {
        const res = await axios.get('/api/v1/staff-attendance', {
          params: { date1, date2 },
        });
        this.attendanceModal.data = res.data.data || [];
      } catch (e) {
        alert('Davomatni yuklashda xatolik: ' + (e.response?.data?.message || e.message));
      } finally {
        this.attendanceModal.loading = false;
      }
    },

    async toggleAttendanceCell(staffId, date) {
      const key = this.attendanceKey(staffId, date);
      this.attendanceModal.cellLoading = key;
      try {
        if (this.hasAttendance(staffId, date)) {
          await axios.delete(`/api/v1/staff-attendance/staff/${staffId}/date/${date}`);
          this.attendanceModal.data = this.attendanceModal.data.filter(
            a => !(Number(a.staff_id) === Number(staffId) && a.attendance_date === date)
          );
        } else {
          const res = await axios.post('/api/v1/staff-attendance', {
            staff_id: staffId,
            attendance_date: date,
          });
          const row = res.data.data || { staff_id: staffId, attendance_date: date };
          if (!this.hasAttendance(staffId, date)) this.attendanceModal.data.push(row);
        }
        if (date === this.localDate()) {
          await this.fetchData();
        }
      } catch (e) {
        alert('Davomatda xatolik: ' + (e.response?.data?.message || e.message));
      } finally {
        this.attendanceModal.cellLoading = null;
      }
    },

    async toggleAttendance(row) {
      const date = this.localDate();
      this.attendanceLoadingId = row.id;
      try {
        if (row.attendedToday) {
          await axios.delete(`/api/v1/staff-attendance/staff/${row.id}/date/${date}`);
        } else {
          await axios.post('/api/v1/staff-attendance', {
            staff_id: row.id,
            attendance_date: date,
          });
        }
        await this.fetchData();
      } catch (e) {
        alert('Davomatda xatolik: ' + (e.response?.data?.message || e.message));
      } finally {
        this.attendanceLoadingId = null;
      }
    },

    openUstaModal(id = null) {
      if (id) {
        const s = this.masters.find(m => m.id === id);
        if (!s) return;
        Object.assign(this.ustaModal, {
          show: true, id: s.id, name: s.name,
          phone: s.phone_number || '+998 ',
          salary: Number(s.salary || 0),
          bonus:  Number(s.bonus  || 0),
        });
      } else {
        Object.assign(this.ustaModal, {
          show: true, id: null, name: '', phone: '+998 ', salary: 0, bonus: 0,
        });
      }
    },

    async saveUsta() {
      if (!this.ustaModal.name.trim()) return alert('Ismni kiriting!');
      this.ustaModal.loading = true;
      const payload = {
        name:         this.ustaModal.name.trim(),
        position:     'Usta',
        phone_number: this.ustaModal.phone,
        salary:       Number(this.ustaModal.salary || 0),
        bonus:        Number(this.ustaModal.bonus  || 0),
      };
      try {
        if (this.ustaModal.id) {
          await axios.put(`/api/v1/staff/${this.ustaModal.id}`, payload);
        } else {
          await axios.post('/api/v1/staff', payload);
        }
        this.ustaModal.show = false;
        this.fetchData();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      } finally { this.ustaModal.loading = false; }
    },

    async deleteMaster(id) {
      const s = this.masters.find(m => m.id === id);
      if (!confirm(`"${s?.name}" o'chirilsinmi?`)) return;
      try {
        await axios.delete(`/api/v1/staff/${id}`);
        this.fetchData();
      } catch (e) {
        alert("O'chirishda xatolik: " + (e.response?.data?.message || e.message));
      }
    },

    // ── To'lov Modal ──
    async openPayModal(row) {
      const s = this.masters.find(m => m.id === row.id) || {};
      // Balansni olish
      let balance = row.kirim_summa - row.chiqim_summa;
      Object.assign(this.payModal, {
        show: true, loading: false,
        staffId: row.id, masterName: row.name,
        masterSalary: Number(s.salary || 0),
        masterBalance: balance,
        reason: 'Oylik',
        amount: 0, displayAmount: '',
        pay_type_id: this.payTypes.length ? this.payTypes[0].id : null,
        comment: '',
      });
    },

    selectReason(val) {
      this.payModal.reason = val;
      this.payModal.amount = 0;
      this.payModal.displayAmount = '';
    },

    fillQuick() {
      const amt = this.quickAmount;
      this.payModal.amount = amt;
      this.payModal.displayAmount = String(amt).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    handleAmount(e) {
      const raw = e.target.value.replace(/\D/g, '');
      this.payModal.amount = Number(raw);
      this.payModal.displayAmount = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    async submitPay() {
      if (!this.payModal.amount)      return alert('Summani kiriting!');
      if (!this.payModal.pay_type_id) return alert("To'lov usulini tanlang!");
      this.payModal.loading = true;
      try {
        await axios.post('/api/v1/user_pay', {
          staff_id:    this.payModal.staffId,
          summa:       this.payModal.amount,
          pay_type_id: this.payModal.pay_type_id,
          datetime:    Math.floor(Date.now() / 1000),
          sklad_id:    Number(localStorage.getItem('sklad_id')),
          reason:      this.payModal.reason,
          comment:     this.payModal.comment || `${this.payModal.masterName} — ${this.payModal.reason}`,
        });
        this.payModal.show = false;
        this.fetchData();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      } finally { this.payModal.loading = false; }
    },

    // ── Tarix Modal ──
    async openHistory(id, name) {
      this.historyModal = { show: true, loading: true, name, data: [] };
      this.historyExpandedId = null;
      try {
        const res = await axios.get(`/api/v1/staff_register/staff/${id}`);
        this.historyModal.data = res.data.data || [];
      } catch (e) { console.error(e); }
      finally { this.historyModal.loading = false; }
    },
    toggleHistoryExpand(id) {
      this.historyExpandedId = this.historyExpandedId === id ? null : id;
    },
    sumServicesTotal(services) {
      return (services || []).reduce((s, x) => s + Number(x.total || 0), 0);
    },
    sumMasterShare(services) {
      return (services || []).reduce((s, x) => s + Number(x.master_share || 0), 0);
    },

    // ── Helpers ──
    fmtM(v) {
      const n = Number(v || 0);
      return n.toLocaleString('ru-RU').replace(/ /g, ' ') + " so'm";
    },
    shortM(v) {
      const n = Number(v || 0);
      if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M';
      if (n >= 1_000)     return (n / 1_000).toFixed(0)     + 'K';
      return String(n);
    },
    fmtDate(d) {
      if (!d) return '';
      return this.$formatDate(d);
    },
  },
};
</script>

<style scoped>
/* ─── Page ─── */
.g-page {
  padding: 28px 32px;
  background: #f8fafc;
  min-height: 100vh;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ─── Header ─── */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.page-title {
  font-size: 28px;
  font-weight: 900;
  color: #5850ec;
  margin: 0;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.search-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.s-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}
.search-input {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 9px 14px 9px 36px;
  font-size: 13px;
  width: 220px;
  outline: none;
  transition: 0.2s;
}
.search-input:focus { border-color: #5850ec; box-shadow: 0 0 0 3px rgba(88,80,236,0.12); }
.btn-add-header {
  display: flex;
  align-items: center;
  gap: 7px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(88,80,236,0.3);
  transition: 0.2s;
}
.btn-add-header:hover { opacity: 0.9; }

/* ─── Table card ─── */
.btn-att-header {
  height: 40px;
  padding: 0 18px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #fff;
  color: #1e293b;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  transition: 0.2s;
}
.btn-att-header:hover {
  border-color: #5850ec;
  color: #4338ca;
  box-shadow: 0 0 0 3px rgba(88,80,236,0.08);
}

.table-card {
  background: white;
  border-radius: 20px;
  border: 1px solid #e8edf3;
  box-shadow: 0 4px 24px rgba(0,0,0,0.04);
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.table-wrap {
  overflow-y: auto;
  flex: 1;
}
.ctable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}
.ctable thead th {
  background: #f8fafc;
  border-bottom: 1.5px solid #e8edf3;
  padding: 14px 12px;
  font-size: 10px;
  font-weight: 800;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 5;
}
.th-left { text-align: left !important; padding-left: 20px !important; }
.ctable tbody td {
  padding: 13px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.td-left { text-align: left !important; padding-left: 20px !important; }
.td-blue  { color: #2563eb; }
.td-red   { color: #e11d48; }
.td-gray  { color: #64748b; }
.td-dark  { color: #1e293b; }
.td-bold  { font-weight: 800; }
.empty-row { text-align: center; padding: 40px; color: #94a3b8; font-weight: 600; }

.m-name { font-weight: 700; color: #1e293b; font-size: 14px; }
.m-phone { font-size: 11px; color: #94a3b8; margin-top: 1px; }

.trow { cursor: pointer; transition: background 0.15s; }
.trow:hover { background: #f8fafc; }

/* Action buttons */
.act-btns { display: flex; gap: 6px; justify-content: center; }
.act-btn {
  width: 32px; height: 32px;
  border: none; border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: 0.15s;
}
.act-btn.pay  { background: #eff6ff; color: #2563eb; }
.act-btn.edit { background: #f5f3ff; color: #5850ec; }
.act-btn.del  { background: #fff1f2; color: #e11d48; }
.act-btn:hover { filter: brightness(0.92); transform: scale(1.07); }

/* ─── Overlay ─── */
.att-btn {
  min-width: 92px;
  height: 32px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #f8fafc;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  transition: 0.15s;
  white-space: nowrap;
}
.att-btn.active {
  border-color: #86efac;
  background: #dcfce7;
  color: #15803d;
}
.att-btn:disabled {
  opacity: 0.6;
  cursor: wait;
}
.att-btn:not(:disabled):hover {
  filter: brightness(0.96);
}

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
}

/* ─── Modal box ─── */
.modal-box {
  background: white;
  border-radius: 24px;
  width: 460px;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}
.pay-modal-box { width: 520px; }
.history-modal-box { width: min(94vw, 900px); max-height: 85vh; }
.attendance-modal-box {
  width: min(96vw, 1280px);
  height: min(88vh, 760px);
}
.attendance-head-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.month-input {
  height: 36px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 0 10px;
  color: #1e293b;
  font-size: 13px;
  font-weight: 700;
}
.attendance-body {
  flex: 1;
  min-height: 0;
  padding: 0;
  overflow: hidden;
}
.attendance-table-wrap {
  height: 100%;
  overflow: auto;
}
.attendance-table {
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.attendance-table th,
.attendance-table td {
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
}
.attendance-table thead th {
  position: sticky;
  top: 0;
  z-index: 4;
  height: 52px;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 900;
  text-align: center;
}
.att-name-col {
  position: sticky;
  left: 0;
  z-index: 3;
  width: 190px;
  min-width: 190px;
  max-width: 190px;
  background: #fff;
  text-align: left;
  padding: 10px 12px;
}
thead .att-name-col {
  z-index: 5;
  background: #f8fafc;
}
.att-day-col {
  width: 42px;
  min-width: 42px;
  padding: 4px 2px;
}
.att-day-col span {
  display: block;
  color: #1e293b;
  font-size: 13px;
}
.att-day-col small {
  display: block;
  color: #94a3b8;
  font-size: 10px;
  margin-top: 2px;
}
.att-day-col.sunday,
.att-day-cell.sunday {
  background: #fff7ed;
}
.att-day-cell {
  height: 42px;
  padding: 4px;
  text-align: center;
  background: #fff;
}
.att-cell-btn {
  width: 30px;
  height: 30px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #16a34a;
  font-size: 17px;
  font-weight: 900;
  line-height: 1;
  cursor: pointer;
}
.att-day-cell.active .att-cell-btn {
  border-color: #86efac;
  background: #dcfce7;
}
.att-cell-btn:disabled {
  opacity: 0.6;
  cursor: wait;
}
.att-total-col {
  position: sticky;
  right: 0;
  z-index: 3;
  width: 64px;
  min-width: 64px;
  background: #f8fafc;
  text-align: center;
  font-weight: 900;
  color: #1e293b;
}
thead .att-total-col {
  z-index: 5;
}

.modal-head {
  padding: 22px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-title { margin: 0; font-size: 18px; font-weight: 800; color: #1e293b; }
.close-btn {
  background: #f1f5f9; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
  display: flex; align-items: center; justify-content: center;
}

.modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.modal-foot {
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  gap: 10px;
}

/* ─── Form fields ─── */
.field-group { display: flex; flex-direction: column; gap: 6px; }
.flabel { font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.3px; }
.finput {
  height: 44px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  outline: none;
  transition: 0.2s;
  width: 100%;
  box-sizing: border-box;
}
.finput:focus { border-color: #5850ec; box-shadow: 0 0 0 3px rgba(88,80,236,0.1); }
.finput-lg { height: 52px; font-size: 18px; font-weight: 800; }
.field-row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }

/* Foot buttons */
.btn-cancel-m {
  flex: 1; height: 46px;
  background: #f1f5f9; color: #64748b;
  border: none; border-radius: 14px;
  font-weight: 700; cursor: pointer;
}
.btn-save-m {
  flex: 2; height: 46px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border: none; border-radius: 14px;
  font-weight: 800; cursor: pointer;
  transition: 0.2s;
}
.btn-save-m:disabled { opacity: 0.6; }
.btn-pay-m {
  flex: 2; height: 46px;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  color: white; border: none; border-radius: 14px;
  font-weight: 800; cursor: pointer;
}
.btn-pay-m:disabled { opacity: 0.6; }

/* ─── Pay modal internals ─── */
.master-badge {
  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
  border: 1px solid #bae6fd;
  border-radius: 14px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
}
.master-avatar {
  width: 44px; height: 44px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border-radius: 50%;
  font-size: 20px; font-weight: 900;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.master-badge-name { font-size: 16px; font-weight: 800; color: #1e293b; }
.master-badge-info { font-size: 12px; color: #64748b; margin-top: 3px; }
.c-red { color: #e11d48; }
.c-green { color: #16a34a; }

/* Reason grid */
.reason-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
.reason-btn {
  height: 56px;
  border: 1.5px solid #e2e8f0;
  background: white;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  color: #475569;
  transition: 0.15s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
}
.reason-btn .r-icon { font-size: 18px; }
.reason-btn:hover { border-color: #5850ec; color: #5850ec; }
.reason-btn.active { background: #5850ec; border-color: #5850ec; color: white; }

/* Amount label row */
.label-row { display: flex; justify-content: space-between; align-items: center; }
.quick-btn {
  background: #ede9fe;
  border: 1.5px solid #a78bfa;
  border-radius: 8px;
  color: #5850ec;
  font-size: 12px; font-weight: 800;
  padding: 3px 10px; cursor: pointer;
  transition: 0.15s;
}
.quick-btn:hover { background: #5850ec; color: white; border-color: #5850ec; }

/* Pay type grid */
.pay-type-grid {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.pay-type-btn {
  flex: 1;
  min-width: 80px;
  height: 40px;
  border: 1.5px solid #e2e8f0;
  background: white;
  border-radius: 10px;
  font-size: 13px; font-weight: 700;
  cursor: pointer; color: #475569;
  transition: 0.15s;
}
.pay-type-btn:hover { border-color: #22c55e; color: #16a34a; }
.pay-type-btn.active { background: #22c55e; border-color: #22c55e; color: white; }

/* History modal */
.type-tag {
  font-size: 11px; font-weight: 800;
  padding: 3px 8px; border-radius: 6px;
  text-transform: uppercase;
}
.tag-red   { background: #fff1f2; color: #e11d48; }
.tag-green { background: #f0fdf4; color: #16a34a; }

.percent-tag {
  display: inline-block;
  background: #ede9fe;
  color: #5850ec;
  font-size: 10px;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 6px;
  margin-left: 6px;
  letter-spacing: 0.3px;
}

.h-clickable {
  cursor: pointer;
  transition: background 0.15s;
}
.h-clickable:hover td { background: #faf8ff; }
.h-expand-icon {
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  color: #64748b;
  background: #f1f5f9;
  border-radius: 6px;
}

.h-detail-row td {
  background: #fafbff !important;
  border-bottom: 2px solid #e2e8f0 !important;
}
.h-detail-container {
  padding: 12px 18px 14px;
}
.h-detail-title {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #5850ec;
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 1px dashed #c7d2fe;
}
.h-inner-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
}
.h-inner-table thead th {
  background: #f1f5f9;
  padding: 8px 10px;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  text-align: left;
}
.h-inner-table tbody td {
  padding: 7px 10px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}
.h-inner-table tbody tr:last-child td { border-bottom: none; }
.h-inner-table tfoot td {
  padding: 8px 10px;
  background: #f8fafc;
  border-top: 1.5px solid #e2e8f0;
  font-size: 12px;
}
.text-right { text-align: right; }
</style>
